import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, ListSubheader, MenuItem } from '@mui/material';
import { majorRiskOptions, doctorGroups } from '../constants/options';
import VoiceTextField from '../../../../components/VoiceTextField';

const ProcedureDetailsSection = ({ formData, handleChange, handleNameChange, handleBlur, setFormData, errors }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 2: Risks & Care Plan
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            2. I have been advised of the major risks and potential complications potential complications involved in the above procedure are listed as follows:
          </Typography>
          <Autocomplete
            multiple
            freeSolo
            options={majorRiskOptions}
            value={formData.advised_of_major_risk ? formData.advised_of_major_risk.split(',').filter(Boolean) : []}
            onChange={(e, val) => setFormData(prev => ({ ...prev, advised_of_major_risk: val.join(',') }))}
            renderInput={(params) => (
              <VoiceTextField
                {...params}
                label={<span>Advised of Major Risk <span style={{ color: 'red' }}>*</span></span>}
                name="advised_of_major_risk"
                onBlur={handleBlur}
                onVoiceTranscript={(text) => {
                  const currentVals = formData.advised_of_major_risk ? formData.advised_of_major_risk.split(',') : [];
                  if (!currentVals.includes(text)) {
                    setFormData(prev => ({ 
                      ...prev, 
                      advised_of_major_risk: [...currentVals, text].filter(Boolean).join(',') 
                    }));
                  }
                }}
                error={!!errors.advised_of_major_risk}
                helperText={errors.advised_of_major_risk || "🎤 Speak or select major risks discussed"}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            3. The Care Plan Dr.
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center', mb: 2 }}>
            <TextField
              select
              size="small"
              name="care_plan_dr"
              value={formData.care_plan_dr || ''}
              onChange={handleChange}
              sx={{ minWidth: 220 }}
              label="Select Doctor"
            >
              <MenuItem value=""><em>Select Doctor</em></MenuItem>
              {Object.entries(doctorGroups).map(([specialty, doctors]) => [
                <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                ...doctors.map((doctor, idx) => (
                  <MenuItem key={`${specialty}-${idx}`} value={doctor}>{doctor}</MenuItem>
                )),
              ])}
            </TextField>
            <Typography variant="body2">
              In the language they understand explaining the various treatment options, risk
            </Typography>
            <TextField
              size="small"
              name="care_plan_risks"
              value={formData.care_plan_risks || ''}
              onChange={handleChange}
              placeholder="e.g., Bleeding, Infection..."
              sx={{ width: 250 }}
            />
            <Typography variant="body2">
              like and benefits
            </Typography>
            <TextField
              size="small"
              name="care_plan_benefits"
              value={formData.care_plan_benefits || ''}
              onChange={handleChange}
              placeholder="e.g., Better recovery..."
              sx={{ width: 250 }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProcedureDetailsSection;
